import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { PdDocumentsData } from '../pd-collect-data.store';

@Component({
  selector: 'app-pd-success',
  templateUrl: './pd-success.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PdSuccessComponent {
  @Input() public showProceedButton: boolean = true;
  @Output() private next = new EventEmitter<PdDocumentsData>();
  constructor() {}

  public redirectHome(): void {
    this.next.emit();
  }
}
